<template>
    <div>
        <div
            v-for="({ id, name, count, description, icon, value, attributes, pivot, performance }, index) in dataCards"
            :key="`${name + index}`"
            class="card-container animated fadeIn"
            :class="updateListBG(count, value)"
        >
            <section v-if="attributes.length > 0 && value" class="animated fadeIn active">
                <HeaderAttribute
                    :blockId="id"
                    :value="value"
                    :title="name"
                    :description="description"
                    :icon="icon"
                    :performanceBlock="performance"
                />
                <NewAttribute :attributesAll="attributes" :existAttribute="attributes" :pivot="pivot" />
            </section>
            <section v-else-if="value" class="animated fadeIn active">
                <HeaderAttribute
                    :blockId="id"
                    :value="value"
                    :title="name"
                    :description="description"
                    :icon="icon"
                    :performanceBlock="performance"
                />
                <NoAttribute :name="name" @createAttribute="createAttribute" />
            </section>
        </div>
    </div>
</template>

<script>
import Loader from '@/views/components/loader'
import { HeaderAttribute } from './components'
export default {
    name: 'Card',
    components: {
        Loader,
        HeaderAttribute,
        NewAttribute: () => import('./components/new-attribute'),
        NoAttribute: () => import('./components/no-attribute'),
    },
    props: {
        cards: {
            type: Array,
        },
    },
    data() {
        return {
            dataCards: { type: Array },
            howManyActiveCards: null,
        }
    },
    updated() {
        this.howManyActiveCards = this.$el.querySelectorAll('.card-container .active').length
    },
    created() {
        this.dataCards = this.cards
    },
    methods: {
        createAttribute(name) {
            this.dataCards.forEach((card) => {
                if (card.name == name) {
                    card.attributes.push({ name: '', description: '' })
                }
            })
        },
        updateListBG(index, value) {
            if (index % 2 == 0 && value == true) return 'bg-color-white'
            if (index % 2 == 1 && value == true) return 'bg-color-gray'
        },
    },
    watch: {
        cards(newValue) {
            this.dataCards = newValue
        },
        howManyActiveCards() {
            let cards = this.$el.querySelectorAll('.card-container .active')
            for (let i = 0; i < cards.length; i++) {
                cards[i].parentElement.classList.remove('bg-color-white')
                cards[i].parentElement.classList.remove('bg-color-gray')

                if (i % 2) {
                    cards[i].parentElement.classList.add('bg-color-white')
                } else {
                    cards[i].parentElement.classList.add('bg-color-gray')
                }
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.bg-color-gray
    background: rgba(228, 229, 230, 0.5)
.bg-color-white
    background: #fff
.card-container
    &::nth-child(2n)
        background: rgba(228, 229, 230, 0.5)
</style>
